export default {
  'containerMgmt-search':{
      key: 'containerMgmt-search',
      label: '容器管理-搜索'
  },
  'containerMgmt-add':{
      key:'containerMgmt-add',
      label:'容器管理-新建'
  },
  'containerMgmt-batchPrint':{
      key:'containerMgmt-batchPrint',
      label:'容器管理-批量打印'
  },
  'containerMgmt-print':{
      key:'containerMgmt-print',
      label:'容器管理-单个打印'
  },
  'containerMgmt-save':{
      key:'containerMgmt-save',
      label:'容器管理-保存'
  },
  'containerMgmt-savePrint':{
      key:'containerMgmt-savePrint',
      label:'容器管理-保存并打印'
  },
  'containerSpecMgmt-add':{
      key: 'containerSpecMgmt-add',
      label: '容器规格管理-新建'
  },
  'containerSpecMgmt-batchDelete':{
      key:'containerSpecMgmt-batchDelete',
      label:'容器规格管理-批量删除'
  },
  'containerSpecMgmt-edit':{
      key:'containerSpecMgmt-edit',
      label:'容器规格管理-编辑'
  },
  'containerSpecMgmt-save':{
      key:'containerSpecMgmt-save',
      label:'容器规格管理-保存'
  },
  'containerSpecMgmt-savePrint':{
      key:'containerSpecMgmt-savePrint',
      label:'容器规格管理-保存并打印'
  },
  'rebinWall-search':{
      key:'rebinWall-search',
      label:'复核墙管理-查询'
  },
  'rebinWall-add':{
      key:'rebinWall-add',
      label:'复核墙管理-新建'
  },
  'rebinWall-gridView':{
      key:'rebinWall-gridView',
      label:'复核墙管理-查看格口'
  },
  'rebinWall-edit':{
      key:'rebinWall-edit',
      label:'复核墙管理-编辑'
  },
  'rebinWall-printWall':{
      key:'rebinWall-printWall',
      label:'复核墙管理-打印墙'
  },
  'rebinWall-printGrid':{
      key:'rebinWall-printGrid',
      label:'复核墙管理-打印格口'
  },
  'rebinWall-save':{
      key:'rebinWall-save',
      label:'复核墙管理-保存'
  },
  'rebinWall-savePrint':{
      key:'rebinWall-savePrint',
      label:'复核墙管理-保存并打印'
  },
}